import http from "../http-common";
import authHeader from "./auth-header";

class EstadisticasDataService {
  getFacturacionAnual() {
    return http.get("/api/estadisticas/facturacion-anual", { headers: authHeader() });
  }

  getFacturacionMensual() {
    return http.get("/api/estadisticas/facturacion-mensual", { headers: authHeader() });
  }

  getFacturacionPorCliente() {
    return http.get("/api/estadisticas/facturacion-por-cliente", { headers: authHeader() });
  }

  getDashboardResumen() {
    return http.get("/api/estadisticas/dashboard-resumen", { headers: authHeader() });
  }
}

export default new EstadisticasDataService();
